<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import type { Favorite } from '~~/server/api/insurance/assistance-services'

export interface PagesAssistenceServicesFavoriteItemProps {
    service: Favorite
}

const props = defineProps<PagesAssistenceServicesFavoriteItemProps>()

const { $t } = useNuxtApp()
</script>

<template>
  <Card
    class="px-3 px-md-6 py-4 py-md-8 h-100 d-flex flex-column justify-content-between"
  >
    <Tracker :data="{ title: props.service.title }">
      <article class="h-100 d-flex flex-column justify-content-between">
        <div>
          <p class="d-block fs-small text-secondary mb-1">
            {{ $t('Asistenčná služba') }}
          </p>
          <h3 class="zeta text-black mb-4">
            {{ props.service.title }}
          </h3>
          <Typo>
            <div v-html="props.service.description_favorites" />
          </Typo>
        </div>
        <VButton
          v-if="props.service.cta_favorites"
          :to="props.service.cta_favorites.link"
          :target="
            props.service.cta_favorites.isExternal
              ? '_blank'
              : '_self'
          "
          :label="props.service.cta_favorites.text"
          color="primary"
          size="small"
          classes="d-flex align-items-center w-100 mt-4 fw-normal"
        >
          {{ props.service.cta_favorites.text }}
        </VButton>
      </article>
    </Tracker>
  </Card>
</template>
